module.exports = __webpack_public_path__ + "img/delete-icon.460d4d34.svg";